// extracted by mini-css-extract-plugin
export var searchHeader = "_1w-0";
export var searchHeaderDark = "_1w-1";